import { supabase } from '@/features/platform/supabase/supabase.client'
import { apiClient } from '@/features/platform/api/client'
import type { Session } from '@supabase/supabase-js'

class AuthService {
  async signInWithOtp (phone: string) {
    const { data, error } = await supabase.auth.signInWithOtp({
      phone,
      options: { channel: 'sms' }
    })

    if (error) {
      throw error
    }

    return data
  }

  async logOut (): Promise<void> {
    await supabase.auth.signOut()
  }

  async getSession (): Promise<Session | null> {
    const { data } = await supabase.auth.getSession()
    return data.session
  }

  async getUser (): Promise<TUser | null> {
    return apiClient.get('/api/me/')
  }

  async getSeniorProfile (): Promise<TSeniorProfile | null> {
    return apiClient.get('/api/senior/profile/')
  }

  async getVolunteerProfile (): Promise<TVolunteerProfile | null> {
    return apiClient.get('/api/volunteer/profile/')
  }

  updateSeniorProfile (data: TSeniorUpdateProfileRequest, signal?: AbortSignal) {
    return apiClient.patch('/api/senior/profile/', data, { signal })
  }

  updateVolunteerProfile (data: TVolunteerUpdateProfileRequest, signal?: AbortSignal) {
    return apiClient.patch('/api/volunteer/profile/', data, { signal })
  }

  async updateUserPhoneNumber (phone: string) {
    return apiClient.patch('/api/me/phone/', { phone })
  }

  async signupSenior (data: TSeniorSignupRequest): Promise<TSeniorSignupResponse> {
    return apiClient.post('/api/signup/senior/', data)
  }

  async signupVolunteer (data: TVolunteerSignupRequest): Promise<TVolunteerSignupResponse> {
    return apiClient.post('/api/signup/volunteer/', data)
  }
}

export const authService = new AuthService()
